import React from "react";
import styled from "@emotion/styled";

import UIcon from "../../../../lib/icons/untitled_ui/UIcon";
import { truncateString } from "../../../../lib/utils/truncateString";
import { Flex } from "../../../../styles/utility-components";
import TooltipComponent from "../../../ui/tooltip/Tooltip";

type Props = {
  children: React.ReactElement;
  supplierName: string;
  totalNotices?: number | null;
  aliases?: string[] | null;
};

export function TooltipContent({ aliases, supplierName, totalNotices }: Omit<Props, "children">) {
  return (
    <Flex gap={12} alignItems="flex-start">
      <StyledIcon icon="magicWand" size={24} />
      <Flex column gap={8}>
        {aliases && aliases.length > 0 ? (
          <div>
            <Paragraph>
              When searching for mentions of {truncateString(supplierName, 100)}, we will also look
              for:
            </Paragraph>
            <AliasList>{aliases?.map((alias) => <li key={alias}>{alias}</li>)}</AliasList>
          </div>
        ) : (
          <Paragraph>
            We will only search for mentions of {truncateString(supplierName, 100)}.
          </Paragraph>
        )}

        {totalNotices ? <TotalNotices>{`${totalNotices} Direct awards`}</TotalNotices> : null}
      </Flex>
    </Flex>
  );
}

export function SupplierTooltip(props: Props) {
  return (
    <TooltipComponent content={<TooltipContent {...props} />} side="left" delayDuration={200}>
      {props.children}
    </TooltipComponent>
  );
}

const StyledIcon = styled(UIcon)({
  // required as something is reducing the width within the tooltip
  minWidth: 24,
});

// Reset the browser-default margins/indent so the copy sits flush with the icon.
const Paragraph = styled.p({
  margin: 0,
});

const AliasList = styled.ul({
  margin: "4px 0 0",
  paddingLeft: 18,
});

const TotalNotices = styled.div(({ theme }) => ({
  width: "fit-content",
  justifyContent: "center",
  alignItems: "center",
  padding: "4px 8px",
  borderRadius: 28,
  background: theme.colors.sysPrimarySubtle,
  color: theme.colors.sysTextDefault,
}));
